<div style="padding:1rem 1rem 0">
  <primary-text-button (onClick)="saveActivityConditionType()" [disabled]="isLoading">{{ 'Save' | translate
    }}</primary-text-button>
</div>
<div class="row card-empty">
  <div class="col-md-12">
    <div class="panel panel-default">
      <div class="table-responsive">
        <div 
          [ngClass]="{'o': isLoading}"
          class="table-overlay"></div>
        <table class="over-colored-bg">
          <thead class="thead-inverse">
            <tr>
              <th class="cell-order"></th>
              <th>
                <div class="d-flex align-items-center">
                  <i *ngIf="lastOrder" class="fas fa-times btn-xs btn-bordered btn-danger btn-icon"
                    (click)="revertSort()"></i>
                  <span (click)="sortItems('name')" class="cursor-pointer">
                    <i class="fas fa-sort"></i> {{ 'classification.name' | translate }}</span>
                </div>
              </th>
              <th *ngFor="let lan of languages; let i = index">
                {{ lan.code | translate }}
              </th>
              <th class="cell-delete">&nbsp;</th>
            </tr>
          </thead>
          <tbody cdkDropList [cdkDropListData]="activityConditionTypes" (cdkDropListDropped)="dropped($event)">
            <tr cdkDrag *ngFor="let row of activityConditionTypes; let i = index">
              <td class="text-center align-middle handlers-cell">
                <i cdkDragHandle class="fas fa-arrows-alt handle mx-1" style="font-size:0.8rem"></i>
              </td>
              <td>
                <input class="form-control form-control-sm" type="text" [(ngModel)]="row.name" #fname="ngModel" required
                  [rangeLength]="[2, 256]" autofocus />
                <p class="validation-error" *ngIf="fname?.errors?.required && (fname?.dirty && fname?.touched)">
                  {{ 'form.validate.required' | translate }}
                </p>
                <p class="validation-error" *ngIf="fname?.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                  {{ 'form.validate.minLenght' | translate }} 2!
                </p>
                <p class="validation-error" *ngIf="fname?.errors?.rangeLength && (fname?.dirty && fname?.touched)">
                  {{ 'form.validate.maxLenght' | translate }} 256!
                </p>
              </td>

              <td *ngFor="let lan of languages; let i = index" class="form-group">
                <input class="form-control form-control-sm" type="text" [ngModel]="getTranslation(lan.code, row.id)"
                  (ngModelChange)="setTranslation($event, lan.code, row.id)" />
              </td>
              <td class="valign-middle text-center table-row-delete">
                <confirmation [showTrashIcon]="true" [buttonName]="'general.delete'" [question]="'confirm.areyousure'"
                  (isConfirmed)="removeActivityConditionType($event, row.id)">
                </confirmation>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <input class="form-control form-control-sm" type="text" [(ngModel)]="name" required
                  [rangeLength]="[2, 256]" autofocus (keyup.enter)="addNewActivityConditionType()" />
              </td>
              <td [attr.colspan]="languages.length + 1">
                <span (click)="addNewActivityConditionType()"
                  class="editBtn  btn-dark {{ name && (name.length >= 2 && name.length <= 256) ? '' : 'block' }} mr-2 "
                  style="position:relative;top:1.5px;">{{ 'Add' | translate }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
